class HeaderDrawer extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.section-header');
    this.progressBarContainer = document.querySelector('.progress-bar-container');
    this.progressBar = document.querySelector('.progress-bar');
    this.isAnimating = false;
  }

  connectedCallback() {
    this.mainDetailsToggle = this.querySelector('details');
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code !== 'Escape') return;
    this.closeMenuDrawer(event, this.querySelector('summary'));
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.closeMenuDrawer(event, event.target.closest('summary'))
      : this.openMenuDrawer(event.target.closest('summary'));

    if (this.getAttribute('data-breakpoint') === 'tablet') {
      event.target.closest('details').hasAttribute('open')
        ? document.documentElement.classList.remove('overflow-hidden-tablet')
        : document.documentElement.classList.add('overflow-hidden-tablet');
    } else {
      event.target.closest('details').hasAttribute('open')
        ? document.documentElement.classList.remove('overflow-hidden')
        : document.documentElement.classList.add('overflow-hidden');
    }
  }

  openMenuDrawer(summaryElement) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    document.body.addEventListener('click', this.onBodyClickEvent);

    summaryElement.closest('details').setAttribute('open', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (!this.mainDetailsToggle.hasAttribute('open')) return;

    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.querySelector('summary').setAttribute('aria-expanded', false);
    });

    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.focus();
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      ) {
        this.closeMenuDrawer();
      }
    });
  }

  onBodyClick(event) {
    if (!this.contains(event.target) && !event.target.closest('sticky-header')) {
      this.closeMenuDrawer(event);
    }
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleFirstFrame = (timestamp) => {
      animationStart = timestamp;
      detailsElement.classList.add('menu-opening');
      window.requestAnimationFrame(handleAnimation);
    };

    const handleAnimation = (timestamp) => {
      if (timestamp - animationStart >= 400) {
        detailsElement.classList.remove('menu-opening');
        return;
      }
      window.requestAnimationFrame(handleAnimation);
    };

    window.requestAnimationFrame(handleFirstFrame);
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.has-submenu');
    detailsElement.classList.remove('menu-opening');
    detailsElement.removeAttribute('open');
    if (parentMenuElement) trapFocus(parentMenuElement, detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }
}

customElements.define('header-drawer', HeaderDrawer);